import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { EventWithUsers, AuditFilters } from '../../../models/staff/audit';

export type AdminAuditState = {
  readonly filters: AuditFilters;
  readonly page: number;
  readonly size: number;
  readonly orderDirection?: 'ASC' | 'DESC';
  readonly orderBy?: 'name' | 'createdAt';
  readonly totalPages: number;
  readonly totalElements: number;
  readonly elements: EventWithUsers[];
};

const initialState: AdminAuditState = {
  filters: {},
  page: 1,
  size: 10,
  totalPages: 0,
  totalElements: 0,
  elements: [],
};

export const adminAuditSlice = createSlice({
  name: 'auditSlice',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    cleanFilters: state => {
      state.filters = {};
    },

    setOrderDirection: (state, action) => {
      if (action.payload) {
        state.orderDirection = action.payload;
      } else {
        state.orderDirection = undefined;
      }
    },

    setOrderBy: (state, action) => {
      if (action.payload) {
        state.orderBy = action.payload;
      } else {
        state.orderBy = undefined;
      }
    },

    setAuditEvents: (
      state,
      action: PayloadAction<{
        readonly events: EventWithUsers[];
        readonly page: number;
        readonly totalPages: number;
        readonly size: number;
        readonly totalElements: number;
      }>
    ) => {
      state.elements = action.payload.events;
      state.size = action.payload.size;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.page;
      state.totalElements = action.payload.totalElements;
    },

    setPage: (state, action) => {
      state.page = action.payload;
    },

    setSize: (state, action) => {
      state.size = action.payload;
    },
  },
});

export default adminAuditSlice.reducer;
